// write your constant variables e.g.
export const BASE_URL =
  process.env.NODE_ENV === 'production' ? '/qhdata/base' : '/api';
